import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import { AuthFile, AuthGet, AuthPost, Post } from "../../_common/httpService";
import Stepper from "../../Components/Stepper";
import brandlogo from "../../assets/images/brand_logo.svg";
import Toast from "../../Components/Toast";
// import Toast from "../../Components/Toast";
import { toast } from "react-hot-toast";
import UserAvatar from "../../Components/UserAvatar/UserAvatar";

// const fileTypes = ["JPG", "PNG", "GIF", "JPEG", "jpg", "png", "jpeg"];
const fileTypes = ["svg"];

const UploadLogo = () => {
  const [file, setFile] = useState(null);
  console.log("file::: ", file);

  const [logo, setLogo] = useState();
  // const [isThemeExists, setIsThemExists] = useState(true);
  // console.log("isThemeExists::: ", isThemeExists);
  // let productId = sessionStorage.getItem("ProductId");
  // let verticalId = sessionStorage.getItem("VerticalId");
  let tenantId = sessionStorage.getItem("tenantId");
  let subscriptionId = sessionStorage.getItem("subscriptionId");

  // const [logoPreview, setLogoPreview] = useState("");

  let navigate = useNavigate();
  const addNewSubscription = JSON.parse(
    sessionStorage.getItem("newSubscription")
  );

  const handleChange = (file) => {
    setFile(URL.createObjectURL(file));
    setLogo(file);
  };

  const getlogo = () => {
    AuthGet(`tenant-theme/logo/${subscriptionId}`).then((res) => {
      setLogo(res);
    });
  };

  // var data;
  useEffect(() => {
    getlogo();
  }, [subscriptionId]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (logo) {
      let formData = new FormData();
      formData.append("file", logo);
      formData.append("tenantId", tenantId);
      formData.append("subscriptionId", subscriptionId);

      AuthFile("tenant-theme", formData)
        .then((res) => {
          // sessionStorage.setItem("themeId", res?.data?.id);
          // navigate("/theme");
          triggerOtp();
          navigate("/verify-otp");
        })
        .catch((err) => {});
    } else if (!file) {
      let svg = `<svg width="158" height="41" viewBox="0 0 158 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_55_79)">
<path d="M11.4745 2.03778C11.4745 2.03778 5.26379 11.3651 14.5928 20.6837C23.9218 30.0024 30.1395 33.1069 29.5436 36.3347C28.9477 39.5625 6.2383 44.1175 4.67655 30.1326C4.67655 30.1326 -0.833956 8.85819 11.4745 2.03778Z" fill="#0B3453"/>
<path d="M11.68 38.663C11.68 38.663 4.00158 30.5013 11.647 19.7581C19.2924 9.01498 24.9056 4.91764 23.7801 1.83429C22.6546 -1.24907 -0.496334 -1.95543 0.294596 12.0941C0.294596 12.0941 -1.59307 33.9894 11.68 38.663Z" fill="url(#paint0_linear_55_79)"/>
</g>
<path d="M54.2907 32.8612C52.4384 32.8612 50.708 32.5322 49.0995 31.8742C47.491 31.1918 46.0774 30.2535 44.8588 29.0592C43.6402 27.865 42.6897 26.4758 42.0073 24.8917C41.3493 23.2831 41.0203 21.5528 41.0203 19.7005C41.0203 17.8726 41.3493 16.1666 42.0073 14.5824C42.6897 12.9983 43.628 11.6213 44.8223 10.4514C46.0408 9.25723 47.4544 8.3311 49.0629 7.67307C50.6715 7.01503 52.4019 6.68601 54.2541 6.68601C55.5458 6.68601 56.8009 6.8688 58.0195 7.23437C59.2625 7.59995 60.3836 8.11175 61.3828 8.76979C62.3821 9.42783 63.1985 10.1834 63.8322 11.0364L61.2732 13.7051C60.542 12.9983 59.7865 12.4134 59.0066 11.9503C58.2511 11.4872 57.4712 11.1338 56.6669 10.8901C55.8626 10.6464 55.0584 10.5246 54.2541 10.5246C52.938 10.5246 51.7194 10.7561 50.5983 11.2191C49.5016 11.6822 48.5268 12.3281 47.6737 13.1567C46.8451 13.9853 46.1993 14.9602 45.7362 16.0813C45.2731 17.178 45.0416 18.3844 45.0416 19.7005C45.0416 20.9678 45.2853 22.1742 45.7727 23.3197C46.2602 24.4408 46.9304 25.4279 47.7834 26.2809C48.6608 27.1339 49.66 27.8041 50.7811 28.2915C51.9266 28.779 53.133 29.0227 54.4003 29.0227C55.3508 29.0227 56.2526 28.8886 57.1056 28.6206C57.9586 28.3281 58.7141 27.926 59.3722 27.4142C60.0302 26.9023 60.542 26.3174 60.9076 25.6594C61.2732 24.977 61.4559 24.258 61.4559 23.5025V22.7713L62.0043 23.2831H54.181V19.3715H65.5138C65.5626 19.6396 65.5991 19.9077 65.6235 20.1758C65.6479 20.4195 65.6601 20.6632 65.6601 20.9069C65.6844 21.1263 65.6966 21.3456 65.6966 21.5649C65.6966 23.2466 65.4042 24.782 64.8192 26.1712C64.2343 27.536 63.4179 28.718 62.3699 29.7173C61.3463 30.7165 60.1399 31.4964 58.7507 32.057C57.3859 32.5931 55.8992 32.8612 54.2907 32.8612Z" fill="#2D2159"/>
<path d="M69.9602 32.4957V5.44305H73.7256V32.4957H69.9602Z" fill="#2D2159"/>
<path d="M87.6617 32.8612C85.6876 32.8612 83.9329 32.4469 82.3974 31.6183C80.8864 30.7653 79.6922 29.6076 78.8148 28.1453C77.9618 26.683 77.5353 25.0014 77.5353 23.1004C77.5353 21.5893 77.779 20.2123 78.2664 18.9694C78.7539 17.7264 79.4241 16.654 80.2771 15.7523C81.1545 14.8262 82.1903 14.1194 83.3845 13.6319C84.6031 13.1201 85.9191 12.8642 87.3327 12.8642C88.5757 12.8642 89.7333 13.108 90.8057 13.5954C91.878 14.0585 92.8042 14.7043 93.5841 15.5329C94.3883 16.3616 94.9976 17.3486 95.4119 18.4941C95.8506 19.6152 96.0578 20.846 96.0334 22.1864L95.9969 23.795H80.3137L79.4728 20.7972H92.7432L92.1949 21.4187V20.5413C92.1218 19.7371 91.8537 19.0181 91.3906 18.3844C90.9275 17.7508 90.3426 17.2511 89.6358 16.8856C88.9291 16.52 88.1613 16.3372 87.3327 16.3372C86.0166 16.3372 84.9077 16.5931 84.006 17.1049C83.1042 17.5924 82.4218 18.3235 81.9587 19.2984C81.4957 20.2489 81.2642 21.4309 81.2642 22.8445C81.2642 24.1849 81.5444 25.3547 82.105 26.354C82.6655 27.3289 83.4576 28.0844 84.4812 28.6206C85.5048 29.1567 86.6869 29.4248 88.0273 29.4248C88.9778 29.4248 89.8552 29.2664 90.6594 28.9496C91.4881 28.6327 92.3777 28.06 93.3282 27.2314L95.2291 29.9001C94.6442 30.485 93.9253 30.9968 93.0723 31.4355C92.2436 31.8742 91.354 32.2276 90.4035 32.4957C89.4774 32.7394 88.5635 32.8612 87.6617 32.8612Z" fill="#2D2159"/>
<path d="M100.126 32.4957V13.3029H103.891V17.2511L103.233 17.6898C103.477 16.8368 103.952 16.0569 104.659 15.3502C105.365 14.619 106.206 14.0341 107.181 13.5954C108.156 13.1323 109.155 12.9008 110.179 12.9008C111.641 12.9008 112.86 13.1933 113.835 13.7782C114.81 14.3387 115.541 15.2039 116.028 16.3738C116.516 17.5436 116.759 19.0181 116.759 20.7972V32.4957H112.994V21.0531C112.994 19.9564 112.848 19.0547 112.555 18.3479C112.263 17.6167 111.812 17.0927 111.203 16.7759C110.593 16.4347 109.838 16.2885 108.936 16.3372C108.205 16.3372 107.535 16.4591 106.925 16.7028C106.316 16.9221 105.78 17.239 105.317 17.6533C104.878 18.0676 104.525 18.555 104.257 19.1156C104.013 19.6518 103.891 20.2367 103.891 20.8703V32.4957H102.027C101.71 32.4957 101.393 32.4957 101.076 32.4957C100.759 32.4957 100.442 32.4957 100.126 32.4957Z" fill="#2D2159"/>
<path d="M121.063 32.4957V29.3517L130.97 16.1179V16.5566H121.063V13.3029H135.065V16.3738L125.304 29.4248L125.158 29.242H135.284V32.4957H121.063Z" fill="#2D2159"/>
<path d="M142.792 40.9039L146.667 31.9473L146.704 34.945L137.126 13.3029H141.512L147.508 27.4142C147.63 27.6579 147.776 28.0356 147.947 28.5474C148.117 29.0349 148.263 29.5223 148.385 30.0097L147.435 30.2291C147.63 29.7173 147.813 29.2055 147.983 28.6937C148.178 28.1819 148.361 27.6701 148.532 27.1582L153.54 13.3029H158L150.103 32.4957L146.85 40.9039H142.792Z" fill="#2D2159"/>
<defs>
<linearGradient id="paint0_linear_55_79" x1="28.6298" y1="-7.56095" x2="-7.64621" y2="42.008" gradientUnits="userSpaceOnUse">
<stop offset="0.21869" stop-color="#0C5893"/>
<stop offset="0.29464" stop-color="#0D69A4"/>
<stop offset="0.42525" stop-color="#0F80BB"/>
<stop offset="0.5653" stop-color="#1090CC"/>
<stop offset="0.72" stop-color="#119AD6"/>
<stop offset="0.91804" stop-color="#119DD9"/>
</linearGradient>
<clipPath id="clip0_55_79">
<rect width="29.7876" height="39.8597" fill="white"/>
</clipPath>
</defs>
</svg>

      `;
      let blob = new Blob([svg], { type: "image/svg+xml" });
      let file = URL.createObjectURL(blob);
      let formData = new FormData();

      formData.append("file", file);
      formData.append("file", blob);
      formData.append("tenantId", tenantId);
      formData.append("subscriptionId", subscriptionId);

      AuthFile("tenant-theme", formData)
        .then((res) => {
          sessionStorage.setItem("themeId", res?.data?.id);
          triggerOtp();
          navigate("/verify-otp");
        })
        .catch((err) => {});
    }

    // const params = {
    //   tenantId: sessionStorage.getItem("tenantId"),
    //   themeId: sessionStorage.getItem("selectedthemeid"),
    //   theme: sessionStorage.getItem("themename"),
    //   subscriptionId: sessionStorage.getItem("subscriptionId"),
    // };
    // console.log("test-params", params);
    // if (!isThemeExists) {
    //   AuthFile("tenant-theme", params)
    //     .then((res) => {
    //       sessionStorage.setItem("build", "Yes");
    //       triggerOtp();
    //       navigate("/verify-otp");
    //     })
    //     .catch((error) => {
    //       console.error("Error creating new theme:", error);
    //     });
    // } else {
    //   AuthFile(`tenant-theme/${params.subscriptionId}`, params, "patch").then(
    //     (res) => {
    //       console.log("res:::2 ", res);
    //       if (res.statusCode === 200) {
    //         triggerBuild();
    //         publish();
    //         sessionStorage.setItem("build", "Yes");
    //         triggerOtp();
    //         navigate("/verify-otp");
    //       }
    //     }
    //   );
    // }
  };

  const triggerOtp = async () => {
    const otpBody = {
      email: sessionStorage.getItem("email"),
      phone: sessionStorage.getItem("phone"),
    };

    await Post(`tenant/generate-otp/${tenantId}`, otpBody)
      .then((res) => {
        if (res.statusCode === 200) {
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => console.log("Err::", err));
    return;
  };

 

  return (
    <>
      <Toast />
      {/* <div className="fullScreen_bg p0"> */}
        <div className="topHeader">
            <div>
              {" "}
              <div className="logosection headerinherit">
                <div className="displayFlex">
                  {/* <img src={menuicon} className="mobileMenuicon" /> */}
                  <div className="brand_logo">
                    <img
                      src={brandlogo}
                      alt="brand_logo"
                    />
                  </div>
                </div>
              </div>
            </div>

                <Stepper />

            <div>
              {addNewSubscription === true ? (
                <UserAvatar
                  logout={true}
                  quickGuide={true}
                  business={true}
                  changePassword={true}
                  profile={true}
                />
              ) : (
                <UserAvatar logout={true} />
              )}
            </div>
        </div>

        {/* <div className="full_header"> */}
          <div className="pagecontentblock">
            {/* <div className="p40"> */}
              <div className="whiteboxblock">
                <h3 className="fontSize16 fontWeight_600 blackText">
                  Upload your logo
                </h3>

                <div className="container-fluid">
                  <div className="row mb_30  ">
                    <div className="col-md-4">
                      <div className="uploadPreview">
                        {file ? (
                          <>
                            <img src={file} alt="logo" />
                          </>
                        ) : logo && logo !== 123 ? (
                          <>
                            <div
                              className="uploadpreviewImg"
                              dangerouslySetInnerHTML={{ __html: logo }}
                            />
                          </>
                        ) : (
                          <>
                            <img src={brandlogo} alt="logo" />
                          </>
                        )}

                        {/* {sessionLogo ? (
                        <img src={sessionLogo} />
                      ) : (
                        <img src={logoPreview} />
                      )} */}

                        {/* <div style={{width: "100px", height: '100px'}}
                        // className="uploadpreviewImg"
                        dangerouslySetInnerHTML={{ __html: file }}
                      /> */}
                      </div>
                      {/* <div className="uploadPreview">
                      <img src={props.data} title="no-image" />
                    </div> */}
                    </div>
                    <div className="col-md-8">
                      <div className="Dragdrop">
                        <FileUploader
                          handleChange={handleChange}
                          name="file"
                          types={fileTypes}
                        />
                      </div>

                      <div className="filetype"> Accepted File Type: .svg</div>
                    </div>
                  </div>

                  <div className="textAlign_center">
                    <button
                      className="Mainbutton"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>

              <div className="uploadLogosection"></div>
            </div>
          {/* </div> */}
        {/* </div> */}
      {/* </div> */}
    </>
  );
};

export default UploadLogo;
